import { useEffect } from "react";
import "../css/home.css";
import { Link, useLocation } from "react-router-dom";
import { CreateCode } from "./reference";
import Head from "./head";

function DocsIcon() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" version="1.1">
         <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(3.610000, 2.750100)" stroke="#fbfbfd" strokeWidth="1.5">
               <line x1="11.9858" y1="12.9463" x2="4.7658" y2="12.9463" id="Stroke-1" />
               <line x1="11.9858" y1="9.1865" x2="4.7658" y2="9.1865" id="Stroke-2" />
               <line x1="7.521" y1="5.4272" x2="4.766" y2="5.4272" id="Stroke-3" />
               <path d="M7.63833441e-14,9.25 C7.63833441e-14,16.187 2.098,18.5 8.391,18.5 C14.685,18.5 16.782,16.187 16.782,9.25 C16.782,2.313 14.685,0 8.391,0 C2.098,0 7.63833441e-14,2.313 7.63833441e-14,9.25 Z" id="Stroke-4" />
            </g>
         </g>
      </svg>
   )
}

function DownloadIcon() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" version="1.1">
         <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(2.000000, 2.000000)" stroke="#fbfbfd" strokeWidth="1.5">
               <line x1="10.0001" y1="14.086" x2="10.0001" y2="5.914" id="Stroke-1" />
               <path d="M13.752,10.3218 C13.752,10.3218 11.224,14.0858 10,14.0858 C8.776,14.0858 6.252,10.3218 6.252,10.3218" id="Stroke-2" />
               <path d="M0.7501,10.0001 C0.7501,16.9371 3.0631,19.2501 10.0001,19.2501 C16.9371,19.2501 19.2501,16.9371 19.2501,10.0001 C19.2501,3.0631 16.9371,0.7501 10.0001,0.7501 C3.0631,0.7501 0.7501,3.0631 0.7501,10.0001 Z" id="Stroke-4" />
            </g>
         </g>
      </svg>
   )
}

function LinkIcon() {
   return (
      <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
         <path d="M149.67,393A95.49,95.49,0,0,1,82.11,230l64.7-64.7a95.65,95.65,0,0,1,135.1,0h0a95.65,95.65,0,0,1,0,135.11l-64.69,64.69A95.23,95.23,0,0,1,149.67,393Zm64.69-225.69A65.29,65.29,0,0,0,168,186.49l-64.7,64.7A65.53,65.53,0,0,0,196,343.86l64.7-64.7a65.51,65.51,0,0,0-46.34-111.84Z" />
         <path d="M295.9,360.71a95,95,0,0,1-24.13-3.1,15,15,0,0,1,7.6-29,65.52,65.52,0,0,0,62.87-17.08l64.7-64.69a65.53,65.53,0,0,0-92.68-92.68l-64.69,64.7a65.84,65.84,0,0,0-17.08,62.89,15,15,0,0,1-29,7.55,95.92,95.92,0,0,1,24.9-91.65l64.69-64.7A95.53,95.53,0,1,1,428.15,268l-64.69,64.69A94.92,94.92,0,0,1,295.9,360.71Z" />
      </svg>
   )
}

const ScrollToHash = () => {
   const { hash } = useLocation();

   useEffect(() => {
      if (hash) {
         const element = document.getElementById(hash.replace('#', ''));
         if (element) {
            element.scrollIntoView({
               block: "start"
            });
         }
      }
   }, [ hash ]);

   return null;
};

export default function Home() {

   function song(e) {
      if (!window.medieval) {
         window.medieval = new Audio("../files/audios/merlin.mp3");
         window.medieval.onended = () => {
            e.target.className = "";
         }
      }

      if (e.target.className === "muted") {
         window.medieval.pause();
         e.target.className = "";
         return
      }

      window.medieval.play();
      e.target.className = "muted";
   }

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   return (
      <main id="home">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "MerlinDB - The IndexedDB API database based on MongoDB",
            description: "MerlinDB is an IndexedDB-based database inspired by MongoDB and Mongoose. Bring your MongoDB and Mongoose skills to MerlinDB.",
            page_author: "Chris Axxwell",
            index: "index, follow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados, tool",
            canonical: "/",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />
         <div id="intro">
            <div onClick={song} >
               <figure></figure>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" version="1.1">
                  <path d="M9.75762445,9.50978128e-06 C10.8009789,9.50978128e-06 11.7740774,0.751539242 12.1253576,1.95611866 C12.254335,2.45963716 12.3067649,2.96422925 12.3570976,3.45057014 L12.3570976,3.45057014 L12.4042845,3.89289342 C12.5846433,5.36909369 12.5846433,12.621263 12.4042845,14.1081993 L12.4042845,14.1081993 L12.3570976,14.5666266 C12.3120079,15.0293483 12.2658696,15.5081739 12.1326977,16.0192076 C11.7814176,17.2205663 10.84502,18.0000095 9.78174219,18.0000095 C9.74818707,18.0000095 9.71463196,18.0000095 9.67688245,17.9989264 C9.08966786,17.9989264 8.451072,17.6381967 8.08930587,17.3236319 L8.08930587,17.3236319 L4.56287255,14.3830409 L2.75194471,14.3830409 C1.35416427,14.3830409 0.330733131,13.370636 0.145131377,11.8042533 C-0.068782508,10.2378706 -0.0268386089,7.55064929 0.145131377,6.12705543 C0.347510691,4.64441356 1.41917731,3.61697817 2.75194471,3.61697817 L2.75194471,3.61697817 L4.56287255,3.61697817 L8.02219563,0.719331237 C8.43953742,0.35645437 9.17565285,-0.00212809548 9.75762445,9.50978128e-06 Z M18.2900621,0.221073385 C18.7074039,-0.0752402689 19.2809867,0.033193351 19.5672539,0.457265429 C21.1359557,2.76657945 22,5.80164721 22,8.99990219 C22,12.2003044 21.1359557,15.2342985 19.5672539,17.5436126 C19.3963325,17.7959086 19.1142597,17.9472862 18.8133123,17.9472862 C18.6266619,17.9472862 18.4463031,17.8893118 18.2911107,17.7798046 C17.8758661,17.4824173 17.7731036,16.8973052 18.0604193,16.4721596 C19.4173044,14.473116 20.1649544,11.8191763 20.1649544,8.99990219 C20.1649544,6.18170168 19.4173044,3.52776199 18.0604193,1.52871842 C17.7731036,1.10464635 17.8758661,0.51846064 18.2900621,0.221073385 Z M15.128331,3.2583957 C15.5467214,2.96315565 16.118207,3.06944207 16.4065713,3.49458774 C17.4195165,4.98689202 17.978419,6.94191798 17.978419,9.00000955 C17.978419,11.0581011 17.4195165,13.0131271 16.4065713,14.5054314 C16.2346014,14.7577274 15.9535772,14.909105 15.6526298,14.909105 C15.4659794,14.909105 15.284572,14.8511306 15.1293796,14.7416234 C14.714135,14.4442361 14.6113725,13.8580504 14.8997368,13.4339784 C15.7019138,12.2519445 16.1433734,10.6769731 16.1433734,9.00000955 C16.1433734,7.32197245 15.7019138,5.74807456 14.8997368,4.56604074 C14.6113725,4.14196866 14.714135,3.55578296 15.128331,3.2583957 Z" />
                  <path d="M17.4201292,0.270845797 C17.7800629,-0.0890452635 18.3538395,-0.0911622697 18.7275354,0.269787294 C19.0906449,0.632853864 19.0906449,1.21926459 18.728594,1.58127266 L18.728594,1.58127266 L1.57987192,18.7290232 C1.40943274,18.8994422 1.16383094,19 0.924580916,19 C0.690624031,19 0.459843032,18.9047347 0.273524427,18.7321987 C-0.090643756,18.3543131 -0.090643756,17.7795459 0.270348541,17.4185963 L0.270348541,17.4185963 L3.09688647,14.592393 L3.0683035,14.592393 C1.65926905,14.592393 0.633458096,13.5974001 0.442904977,12.0519855 C0.230120661,10.506571 0.272465798,7.86031317 0.442904977,6.45250402 C0.642985752,4.99176971 1.72384539,3.98725025 3.0683035,3.98725025 L3.0683035,3.98725025 L4.89867207,3.98725025 L8.39214592,1.12929183 C8.81665592,0.769400767 9.56828211,0.429621265 10.1494691,0.420094737 C11.2080976,0.420094737 12.1820357,1.15998842 12.5313831,2.34551191 C12.6690048,2.84406688 12.7229949,3.34050484 12.76534,3.81788975 L12.76534,3.81788975 L12.8489716,4.49427325 C12.8627338,4.59800655 12.8754374,4.69750584 12.8860236,4.80335616 L12.8860236,4.80335616 Z M12.4160158,10.5204247 L12.48745,10.5281644 C12.8759667,10.6266052 12.9521879,11.1844364 12.9458361,11.6226567 C12.9278395,12.8949774 12.8854943,13.779886 12.8177421,14.3271321 L12.8177421,14.3271321 L12.7701038,14.7780545 C12.7245828,15.2342693 12.6780032,15.7063617 12.5424987,16.2102092 C12.1899754,17.3936157 11.2446202,18.1620889 10.1701124,18.1620889 C10.1351776,18.1620889 10.1002429,18.1620889 10.0642495,18.1610304 C9.47035898,18.1610304 8.82671289,17.8053734 8.46148608,17.495232 L8.46148608,17.495232 L7.16043173,16.4885955 C6.66605225,16.1212949 6.81214298,15.5348842 7.08950363,15.1951047 C7.21557665,15.0411406 8.18724007,14.1341959 9.22324838,13.1772884 L9.63923159,12.7935271 C10.7477949,11.7719454 11.8110506,10.8001677 11.8808559,10.731397 C12.0237708,10.5916746 12.3434766,10.4911168 12.48745,10.5281644 Z" />
               </svg>
            </div>
            <p>by, <a href='https://instagram.com/chrisaxxwell.dev' rel="noreferrer" target="_blank">Chris Axxwell</a></p>
            <h1><Link to="./" reloadDocument>MerlinDB</Link > the <a href='https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API' target="_blank" rel="noreferrer">indexedDB API</a> database based on <a href='https://www.mongodb.com/docs/manual/' target="_blank" rel="noreferrer">MongoDB</a>.'Alakazam'</h1>
            <h2>This entire site is using MerlinDB, so, you can test it in the dashboard and interestingly check the element inspector in IndexedDB. Bring your mongoDB and mongoose techniques to indexedDB!</h2>
            <div>
               <Link to="./docs"><DocsIcon />Read de docs</Link>
               <Link to="./download"><DownloadIcon />Download</Link>
            </div>
            <code >
               <CreateCode content={`
import MerlinDB, {Schema} from "@chrisaxxwell/merlin-db";
//Or if you are using '<a href="/download" link-react to='/download' class="schema1">merlindb.max.js</a>' just call 'new MerlinDB()'; 

const merlin = new MerlinDB();
merlin.connect("MY-CATS-DATABASE");

const Cats = merlin.model('Cats-model', { 
   name: {type: String, required: true}, 
   breed: String
});

Cats.insertOne({ name: "Alvin" }).then(data => { 
   console.log(data);
   //Success <li data-disappear='Hello'></li> 🔮
});

Cats.find({ name: "Alvin" }).then(data => { 
   console.log(data);
   //{ name: "alvin", breed: "Siamese" };🔮
});
               `} />
            </code>
            <p> MerlinDB is an IndexedDB-based database designed to store data locally in web browsers. Unlike conventional databases such as MongoDB, MerlinDB is optimized for web applications, offering an efficient and lightweight solution for storing data at browser runtime.</p>
            <h3>🔮 Why MerlinDB?</h3>
            <h4>MerlinDB was carefully developed to simplify and improve the use of the IndexedDB API in web browsers. MerlinDb allows developers to add, get, update and remove data at scale, providing a fluid and effective experience. Inspired by the renowned MongoDB and Mongoose, MerlinDB is a sophisticated and intuitive tool especially designed for those familiar with MongoDB and Mongoose. Its intuitive interface and powerful features make it the ideal choice for professionals looking for superior productivity and performance in their web development projects.</h4>
            <h3>🔮 Getting started</h3>
            <Link to="./docs#introduction" ><LinkIcon />Introduction</Link>
            <Link to="./docs#getting-start" ><LinkIcon />Guetting Start</Link>
            <Link to="./docs#crud" ><LinkIcon />CRUD</Link>
            <Link to="./guides" ><LinkIcon />Guides</Link>
            <h3>🔮 News</h3>
            <Link to="https://x.com/chrisaxxwell.dev" rel="noreferrer" target="_blank"><LinkIcon />Twitter</Link>
            <h3>🔮 Support</h3>
            <Link to="https://github.com/chrisaxxwell/merlin-db" rel="noreferrer" target="_blank"><LinkIcon />GitHub</Link>
            <Link to="https://www.mongodb.com/docs/manual/" rel="noreferrer" target="_blank"><LinkIcon />MongoDB Manual</Link>
            <Link to="https://www.buymeacoffee.com/chrisaxxwell" rel="noreferrer" target="_blank"><LinkIcon />Buy me a coffee ☕️</Link>
         </div>
      </main>
   )
}

export { ScrollToHash, DocsIcon };